import { appendAndReplaceQueryParams } from '@office-start/url-parser-utility';
export function appendQueryInformation(componentContext, url, isEncoded, area) {
    var officeRouteItem = componentContext.router.getCurrentRoute();
    var params = {
        route: area ||
            (officeRouteItem && officeRouteItem.route
                ? officeRouteItem.route
                : undefined),
    };
    return appendAndReplaceQueryParams(url, params, isEncoded !== null && isEncoded !== void 0 ? isEncoded : false);
}
//# sourceMappingURL=appendQueryInformation.js.map